import { render, staticRenderFns } from "./ProductListSlider.vue?vue&type=template&id=309312b5"
import script from "./ProductListSlider.vue?vue&type=script&lang=js"
export * from "./ProductListSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductListSlider.vue?vue&type=style&index=0&id=309312b5&prod&global=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports